import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying | success | error | code
  const [errorMsg, setErrorMsg] = useState('');
  const [code, setCode] = useState('');
  const [codeLoading, setCodeLoading] = useState(false);
  const navigate = useNavigate();
  const { setTokenAndUser } = useAuth();
  const token = searchParams.get('token');
  const error = searchParams.get('error');

  useEffect(() => {
    if (error) {
      setStatus('error');
      setErrorMsg('Ссылка недействительна или устарела.');
      return;
    }
    if (token) {
      verifyByToken();
    } else {
      setStatus('error');
      setErrorMsg('Токен подтверждения не найден.');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const verifyByToken = async () => {
    setStatus('verifying');
    try {
      const response = await axios.post('/api/auth/verify-email', { token });
      setTokenAndUser(response.data.token, response.data.user);
      setStatus('success');
      setTimeout(() => navigate('/dashboard'), 2000);
    } catch (err) {
      const msg = err.response?.data?.message || 'Ошибка подтверждения';
      setErrorMsg(msg);
      if (msg.includes('уже подтверждён')) {
        setStatus('error');
      } else {
        setStatus('code');
      }
    }
  };

  const handleCodeSubmit = async (e) => {
    e.preventDefault();
    setCodeLoading(true);
    try {
      const response = await axios.post('/api/auth/verify-email', { token, code });
      setTokenAndUser(response.data.token, response.data.user);
      setStatus('success');
      setTimeout(() => navigate('/dashboard'), 2000);
    } catch (err) {
      setErrorMsg(err.response?.data?.message || 'Неверный код');
    } finally {
      setCodeLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">

        {status === 'verifying' && (
          <div style={{ textAlign: 'center' }}>
            <div className="verify-spinner" />
            <h2>Подтверждение...</h2>
            <p className="auth-subtitle">Пожалуйста, подождите</p>
          </div>
        )}

        {status === 'success' && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '56px', marginBottom: '16px' }}>✅</div>
            <h2>Email подтверждён!</h2>
            <p className="auth-subtitle">Перенаправляем в личный кабинет...</p>
          </div>
        )}

        {status === 'error' && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '56px', marginBottom: '16px' }}>❌</div>
            <h2>Ошибка</h2>
            <div className="error-message" style={{ marginBottom: '1.5rem' }}>{errorMsg}</div>
            <Link to="/register" className="btn btn-primary" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
              Зарегистрироваться заново
            </Link>
            <p className="auth-footer"><Link to="/">Войти</Link></p>
          </div>
        )}

        {status === 'code' && (
          <>
            <h2>Введите код</h2>
            <p className="auth-subtitle">
              Ссылка не сработала — введите 6-значный код из письма вручную
            </p>
            {errorMsg && <div className="error-message">{errorMsg}</div>}
            <form onSubmit={handleCodeSubmit}>
              <div className="form-group">
                <label>Код подтверждения</label>
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  value={code}
                  onChange={(e) => { setErrorMsg(''); setCode(e.target.value.replace(/\D/g, '')); }}
                  placeholder="000000"
                  style={{ letterSpacing: '8px', fontSize: '1.4rem', textAlign: 'center' }}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={codeLoading || code.length !== 6}>
                {codeLoading ? 'Проверка...' : 'Подтвердить'}
              </button>
            </form>
            <p className="auth-footer"><Link to="/register">Зарегистрироваться заново</Link></p>
          </>
        )}

      </div>

      <style>{`
        .verify-spinner {
          width: 48px;
          height: 48px;
          border: 4px solid rgba(74,144,226,0.2);
          border-top-color: #4a90e2;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
          margin: 0 auto 20px;
        }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
};

export default VerifyEmail;
